import {VGLawCookie} from "vglawcookie";

var lastScrollTop = 0,
	$body = $('body');

window.VegasListener = {
	onReady: () => {
		Vegas.carousel();
		Vegas.bg();
		Vegas.enablePlugins();
		Vegas.other();
		Vegas.fixedHeader($(window));
		Vegas.fixedScrollTo($(window));
	},

	onLoad: () => {
		Vegas.preloader();
	},

	onClick: () => {
		Vegas.popup();
		Vegas.toggle();
	},

	onSubmit: () => {
		Vegas.forms();
	},

	onScroll: ($self) => {
		Vegas.fixedHeader($self);
		Vegas.fixedScrollTo($self);
	},
};

window.Vegas = {
	log: function () {
		console.group('vegas studio');
		console.log("%cvegas app was initialization", "color: green;");
		console.log('https://vegas-dev.com/');
		console.groupEnd();
	},

	preloader: function () {

	},

	forms: function () {
		$('.form-vegas').vegasFormSender({
			beforeSend: function (form) {
				AlertFormSender.Action.beforeSend(form);
			},
			success: function (data, form) {
				AlertFormSender.Action.success(data.msg, form);
			},
			error: function (msg, form) {
				AlertFormSender.Action.error(msg, form);
			},
			validate: function (form, errors) {
				AlertFormSender.Action.validate(errors, form);
			}
		});
	},

	toggle: function () {
		$('[data-toggle=vg-hdr-catalog], [data-toggle=show-sub-categories]').click(function () {
			let $_self = $(this);
			let $li = $_self.hasClass('back') ? $_self.closest('li.show') : $_self.parent('li');

			if ($li.hasClass('show')) {
				$li.removeClass('show');
			} else {
				$li.closest('ul').find('.show').removeClass('show');
				$li.addClass('show');
			}

			return false;
		});

		$('[data-toggle=get-reviews]').click(function () {
			let $self = $(this),
				target = $self.data('target'),
				$tabs = $('#tabs');

			$tabs.find(target).tab('show');

			$('html, body').animate({
				scrollTop: $tabs.offset().top
			}, 1000);

			return false;
		});

		$('[data-toggle=show-all-variants]').click(function () {
			let $self = $(this),
				$container = $self.closest('ul');

			if ($container.find('.hide').length) {
				$container.find('.hide').removeClass('hide').addClass('shown');
				$self.text('Скрыть');
			} else if ($container.find('.shown').length) {
				$container.find('.shown').removeClass('shown').addClass('hide');
				$self.text('Еще');
			}

			return false;
		});

		$(document).on('click', '[data-disable]', function () {
			let $form = $(this).closest('form');
			let error = false;
			
			$form.find('input[required]').each(function () {
				if ($(this).val() === '') error = true;
			});
			
			if (!error) {
				$(this).attr('disabled', true);

				return $form.submit();
			} else {
				return true;
			}
		});

		// Mouse UP
		$(document).mouseup(function (e) {
			let $hdr_catalog = $('.vg-hdr-catalog');
			if ($hdr_catalog.has(e.target).length === 0) {
				$hdr_catalog.find('.show').removeClass('show');
				$hdr_catalog.find('.is-active').removeClass('is-active');
			}

			let $hdr_cart = $('.cart-dropdown');
			if ($hdr_cart.has(e.target).length === 0) {
				$hdr_cart.removeClass('show');
			}

			let $mobile_search = $('.vg-hdr-search-mobile__container');
			if ($mobile_search.has(e.target).length === 0 && $('.vg-hdr-search-mobile').has(e.target).length === 0) {
				$mobile_search.removeClass('show');
			}
		});
	},

	enablePlugins: function () {
		// niceSelect;
		$(".nice-select").niceSelect();

		// vg nav
		$('.vg-menu').vegasMenu();

		// tags
		$('.tags-wrapper').vegasCountElement();

		// tags
		$('[data-toggle="tooltip"]').tooltip();

		// input mask
		$('.input-mask-phone').inputmask('9 (999) 999-99-99', {"clearIncomplete": true}).on('paste', function (e) {
			$(this).val(normalize_phone_inputmask(e.originalEvent.clipboardData.getData('text')));
			return false;
		}).on('change', function () {
			$(this).val(normalize_phone_inputmask($(this).val()));
		});
		$('.input-mask-card').inputmask('9999 9999 99999', {"clearIncomplete": true});
		
		let $ranges = $(".js-range-slider");
		if ($ranges.length) {
			$ranges.each(function () {
				let $ionRange = $(this);

				$ionRange.ionRangeSlider({
					skin: "round",
					onChange: function (data) {
						$ionRange.closest('.vg-shop-sidebar__widget').find('[data-number=from]').val(data.from);
						$ionRange.closest('.vg-shop-sidebar__widget').find('[data-number=to]').val(data.to);
					}
				});
			});
		}
		
		$('[data-number]').on('input keyup', function () {
			let $_self = $(this),
				type = $_self.data('number'),
				$range = $_self.closest('.vg-shop-sidebar__widget').find('.js-range-slider'),
				$slider = $range.data("ionRangeSlider");
			
			if (type === 'from') {
				$slider.update({
					from: $_self.val()
				});
			}
			
			if (type === 'to') {
				$slider.update({
					to: $_self.val()
				});
			}
			
			return false
		});

		let $paroller_gift = $('.vg-ny-gift');
		if($paroller_gift.length) {
			$paroller_gift.paroller();
		}

		new VGLawCookie({
			enableLinkMore: true,
		});
	},

	popup: function () {
		$('[data-modal]').click(function () {
			let $target = $(this).data('modal'),
				id = $(this).data('id') || false,
				title = $(this).data('title') || false,
				lat = $(this).data('lat') || false,
				lon = $(this).data('lon') || false;

			if (title) {
				$($target).find('.modal-title').text(title);
			}

			if (id) {
				$($target).find('form input[name=id], .input-id').val(id);
			}
			
			if (lat && lon) {
				let map = $('.yaMapOrder'),
					id = map.attr('id');
				Vegas.map(id, lat, lon)
			}

			$($target).modal('show');

			return false;
		});
		
		// close modal
		$('#modal-showMap').on('hide.bs.modal', function (e) {
			$('#yaMap > ymaps').remove();
		});
	},

	bg: function () {
		let $bg = $('[data-bg]');
		if ($bg.length) {
			$bg.each(function () {
				let $self = $(this),
					bg = $self.data('bg'),
					repeat = $self.data('repeat') || 'no-repeat',
					position = $self.data('position') || 'center',
					size = $self.data('size') || 'cover',
					attachment = $self.data('attachment') || 'inherit';

				$self.css({
					'background-image': 'url(' + bg + ')',
					'background-position': position,
					'background-repeat': repeat,
					'background-size': size,
					'background-attachment': attachment
				});
			});
		}
	},

	carousel: function () {
		/*--- owl ------------------------*/
		let $owl = $('.owl-carousel');
		if ($owl.length) {
			$owl.each(function () {
				let $self = $(this);

				let custom = $self.data('custom') || false;

				if (custom) {
					let $owlCompare = $('.owl-compare');
					let $owlCompareOption = $('.owl-compare-option');

					$owlCompare.owlCarousel({
						loop: false,
						margin: 30,
						autoHeightClass: 'owl-height',
						autoplay: false,
						dots: false,
						nav: true,
						navText: ['<i class="icon fal fa-chevron-left">', '<i class="icon fal fa-chevron-right">'],
						responsive: {
							0: {
								items: 2
							},
							480: {
								items: 2
							},
							768: {
								items: 3
							},
							992: {
								items: 4
							},
							1200: {
								items: 5
							}
						}
					});

					$owlCompareOption.owlCarousel({
						loop: false,
						margin: 30,
						autoHeight: true,
						autoplay: false,
						dots: false,
						nav: false,
						mouseDrag: false,
						touchDrag: false,
						pullDrag: false,
						freeDrag: false,
						responsive: {
							0: {
								items: 2
							},
							480: {
								items: 2
							},
							768: {
								items: 3
							},
							992: {
								items: 4
							},
							1200: {
								items: 5
							}
						}
					});

					$owlCompare.on('change.owl.carousel', function (event) {
						if (event.namespace && event.property.name === 'position') {
							let target = event.relatedTarget.relative(event.property.value, true);
							$owlCompareOption.owlCarousel('to', target, 300, true);
						}
					});
				} else {
					let items = $self.data('items') || 1,
						loop = $self.data('loop') || false,
						autoplay = $self.data('autoplay') || false,
						autoplayTimeout = $self.data('autoplayTimeout') || 5000,
						dots = $self.data('dots') || false,
						nav = $self.data('nav') || false,
						margin = $self.data('margin') || 0,
						stagePadding = $self.data('stagePadding') || 0,
						animateOut = $self.attr('data-animateOut') || false,
						animateIn = $self.attr('data-animateIn') || false,
						smartSpeed = $self.data('smartSpeed') || 250,
						autoWidth = $self.data('autowidth') || false,
						responsive = {
							1200: {
								items: items
							},
							992: {
								items: items === 1 ? 1 : 4
							},
							768: {
								items: items === 1 ? 1 : 3
							},
							480: {
								items: items === 1 ? 1 : 2
							},
							0: {
								items: 1
							}
						};

					// responsive
					let xs = $self.data('xs') || false; // 0px
					if (xs) {
						let params = {
							0: xs
						};

						responsive = $.extend(responsive, params);
					}

					let sm = $self.data('sm') || false; // 480px
					if (sm) {
						let params = {
							480: sm
						};

						responsive = $.extend(responsive, params);
					}

					let md = $self.data('md') || false; // 768px
					if (md) {
						let params = {
							768: md
						};

						responsive = $.extend(responsive, params);
					}

					let lg = $self.data('lg') || false; // 992
					if (lg) {
						let params = {
							992: lg
						};

						responsive = $.extend(responsive, params);
					}

					let xl = $self.data('xl') || false; // 992
					if (xl) {
						let params = {
							1200: xl
						};

						responsive = $.extend(responsive, params);
					}

					// animation
					let animatedIn = {}, animatedOut = {};

					if (animateIn) {
						animatedIn = {
							animateIn: animateIn
						}
					}
					if (animateOut) {
						animatedOut = {
							animateOut: animateOut
						}
					}

					// navigation
					let navigation = {}, navText = {};
					if (nav) {

						switch (nav) {
							case 'chevron-icon':
								navText = {
									navText: ["<span class='vg-owl-chevron'><i class='fa fa-chevron-left'></i></span>", "<span class='vg-owl-chevron'><i class='fa fa-chevron-right'></i></span>"],
								};
								break;
							case 'words':
								navText = {
									navText: ["<i class='fal fa-chevron-left'></i> Предыдущий", "Следующий <i class='fal fa-chevron-right'></i>"],
								};
								break;
							default:
								navText = {
									navText: ["<i class='fal fa-chevron-left'></i>", "<i class='fal fa-chevron-right'></i>"],
								};
						}

						navigation = $.extend({
							nav: true
						}, navText);
					}

					let options = {
						items: items,
						loop: loop,
						autoplay: autoplay,
						autoplayTimeout: autoplayTimeout,
						margin: margin,
						stagePadding: stagePadding,
						dots: dots,
						smartSpeed: smartSpeed,
						autoWidth: autoWidth,
						responsive: responsive
					};

					options = $.extend(options, animatedOut, animatedIn, navigation);

					$self.owlCarousel(options);
				}
			});
		}

		/*--- slick ------------------------*/
		let $html = $('html');
		let $body = $('body');
		let $uptimoSlickSlider = $('.petmark-slick-slider');

		/*For RTL*/
		if ($html.attr("dir") === "rtl" || $body.attr("dir") === "rtl") {
			$uptimoSlickSlider.attr("dir", "rtl");
		}

		$uptimoSlickSlider.each(function () {

			/*Setting Variables*/
			let $this = $(this),
				$setting = $this.data('slick-setting') ? $this.data('slick-setting') : '',
				$autoPlay = $setting.autoplay ? $setting.autoplay : false,
				$autoPlaySpeed = parseInt($setting.autoplaySpeed, 10) || 2000,
				$asNavFor = $setting.asNavFor ? $setting.asNavFor : null,
				$appendArrows = $setting.appendArrows ? $setting.appendArrows : $this,
				$appendDots = $setting.appendDots ? $setting.appendDots : $this,
				$arrows = $setting.arrows ? $setting.arrows : false,
				$prevArrow = $setting.prevArrow ? '<button class="' + ($setting.prevArrow.buttonClass ? $setting.prevArrow.buttonClass : 'slick-prev') + '"><i class="' + $setting.prevArrow.iconClass + '"></i></button>' : '<button class="slick-prev">previous</button>',
				$nextArrow = $setting.nextArrow ? '<button class="' + ($setting.nextArrow.buttonClass ? $setting.nextArrow.buttonClass : 'slick-next') + '"><i class="' + $setting.nextArrow.iconClass + '"></i></button>' : '<button class="slick-next">next</button>',
				$centerMode = $setting.centerMode ? $setting.centerMode : false,
				$centerPadding = $setting.centerPadding ? $setting.centerPadding : '50px',
				$dots = $setting.dots ? $setting.dots : false,
				$fade = $setting.fade ? $setting.fade : false,
				$focusOnSelect = $setting.focusOnSelect ? $setting.focusOnSelect : false,
				$infinite = $setting.infinite ? $setting.infinite : false,
				$pauseOnHover = $setting.pauseOnHover ? $setting.pauseOnHover : true,
				$rows = parseInt($setting.rows, 10) || 1,
				$slidesToShow = parseInt($setting.slidesToShow, 10) || 1,
				$slidesToScroll = parseInt($setting.slidesToScroll, 10) || 1,
				$swipe = $setting.swipe ? $setting.swipe : true,
				$swipeToSlide = $setting.swipeToSlide ? $setting.swipeToSlide : false,
				$variableWidth = $setting.variableWidth ? $setting.variableWidth : false,
				$vertical = $setting.vertical ? $setting.vertical : false,
				$verticalSwiping = $setting.verticalSwiping ? $setting.verticalSwiping : false,
				$rtl = $setting.rtl || $html.attr('dir="rtl"') || $body.attr('dir="rtl"') ? true : false;

			/*Responsive Variable, Array & Loops*/
			let $responsiveSetting = typeof $this.data('slick-responsive') !== 'undefined' ? $this.data('slick-responsive') : '',
				$responsiveSettingLength = $responsiveSetting.length,
				$responsiveArray = [];
			for (let i = 0; i < $responsiveSettingLength; i++) {
				$responsiveArray[i] = $responsiveSetting[i];
			}


			/*Slider Start*/
			$this.slick({
				autoplay: $autoPlay,
				autoplaySpeed: $autoPlaySpeed,
				asNavFor: $asNavFor,
				appendArrows: $appendArrows,
				appendDots: $appendDots,
				arrows: $arrows,
				dots: $dots,
				centerMode: $centerMode,
				centerPadding: $centerPadding,
				fade: $fade,
				focusOnSelect: $focusOnSelect,
				infinite: $infinite,
				pauseOnHover: $pauseOnHover,
				rows: $rows,
				slidesToShow: $slidesToShow,
				slidesToScroll: $slidesToScroll,
				swipe: $swipe,
				swipeToSlide: $swipeToSlide,
				variableWidth: $variableWidth,
				vertical: $vertical,
				verticalSwiping: $verticalSwiping,
				rtl: $rtl,
				prevArrow: $prevArrow,
				nextArrow: $nextArrow,
				responsive: $responsiveArray
			});

		});
	},

	fixedHeader: function ($self) {
		let $sticky = $('.vg-hdr-sticky'),
			scroll = $self.scrollTop();

		if (scroll > 345) {
			$body.addClass('vg-hdr--is-scroll');

			if (scroll > lastScrollTop) {
				$sticky.css('top', -70);
				$body.removeClass('vg-hdr--is-fixed');
			} else {
				$sticky.css('top', 0);
				$body.addClass('vg-hdr--is-fixed');
			}

			lastScrollTop = scroll;
		} else {
			$sticky.css('top', -70);
			$body.removeClass('vg-hdr--is-scroll vg-hdr--is-fixed');
		}

		Vegas.removeClasses('.dropdown-mega-container', 'vg-hdr--is-scroll');
		Vegas.removeClasses('.vg-search-content', 'vg-hdr--is-scroll');
		Vegas.removeClasses('.cart-dropdown-content', 'vg-hdr--is-scroll');
	},
	
	fixedScrollTo: function ($self) {
		let $sticky = $('.vg-scroll-top'),
			scroll = $self.scrollTop();
		
		if (scroll > 400) {
			$sticky.addClass('is-active');
		} else {
			$sticky.removeClass('is-active');
		}
	},

	removeClasses: function (target, bodyClass = '') {
		if (target === '.dropdown-mega-container') {
			let $container = $(target).closest('li');

			if ($body.hasClass(bodyClass) && $container.hasClass('show')) $container.removeClass('show');
		}

		if (target === '.cart-dropdown-content') {
			let $container = $(target).closest('.cart-dropdown');

			if ($body.hasClass(bodyClass) && $container.hasClass('show')) $container.removeClass('show');
		}

		if (target === '.vg-search-content') {
			if ($body.hasClass(bodyClass) && $(target).hasClass('focused')) $(target).removeClass('focused');
		}
	},

	other: function () {
		// page
		let $pageText = $('.page-default');
		$pageText.find('table').addClass('table table-hover table-striped');
	},
	
	map: function (id ,lat, lon) {
		var myMap;
		yaMapInit(id);
		function yaMapInit(map_ID) {
			ymaps.ready(init);
			
			function init() {
				myMap = new ymaps.Map(map_ID, {
					center: [lat, lon],
					zoom: 17,
					controls: ['zoomControl']
				}, {
					searchControlProvider: 'yandex#search',
					suppressMapOpenBlock: true
				});
				myMap.geoObjects
					
					.add(new ymaps.Placemark([lat, lon], {
						balloonContent: ''
					}, {
						iconLayout: 'default#image',
						iconImageHref: '/assets/_frontend/images/icons/marker.png',
						iconImageSize: [115, 120],
						iconImageOffset: [-40, -115]
					}));
				
				if (window.innerWidth < 1000) {
					myMap.behaviors.get('drag').disable();
				}
				
				myMap.behaviors.disable('scrollZoom');
			}
			
			return false;
		}
	}
};